const CUSTOMIZATION = {
    CUSTOMIZATIONS: {
        url: '/contractsAccesses/:contractAccessId/personalizationsData',
        queryKey: 'getCustomizations'
    },
    FETCH_PACKAGE_CUSTOMIZATION: {
        url: '/package/:packageId',
        queryKey: 'getPackageCustomization'
    },
    CREATE_PACKAGE_CUSTOMIZATION: {
        url: '/package'
    },
    UPDATE_PACKAGE_CUSTOMIZATION: {
        url: '/package/:uuid'
    },
    DELETE_PACKAGE_CUSTOMIZATION: {
        url: '/package/:uuid'
    },
    UPLOAD_PACKAGE_CUSTOMIZATION: {
        url: '/package/:uuid/publish'
    }
};

export default CUSTOMIZATION;